import React from 'react';
import OfflineDriveCandidates from '../../components/driveAdmin/offlineDriveCandidatesList/OfflineDriveCandidates';

const OfflineDriveCandidatesPage = () => {
	return (
		<div>
			<OfflineDriveCandidates />
		</div>
	);
};

export default OfflineDriveCandidatesPage;
